export default __webpack_public_path__ + "static/media/cognota-dotted.12ed3ded.svg";